import React, { FC, useContext, useEffect, useState } from 'react';

import { GlobalContext } from '../../../../../store';

import { Button } from '../../../../../components/Button/Button';
import { useRouteInfoState } from '../../../../../components/RouteInfo/Context/RouteInfo.context';
import { INDIVIDUAL_SECTION, TEAMS_SECTION, TSection } from '../RoundFlights';

interface IButtonMetadata {
  display: boolean;
  inClass: string;
  variant: 'contained' | 'outlined';
  title: string;
  section: TSection;
}
interface IProps {
  flightsSection: TSection;
  onSectionClick: (section: TSection) => () => void;
}

export const FlightsSectionSelector: FC<IProps> = props => {
  const { flightsSection, onSectionClick } = props;

  const { adminRoundFormats } = useContext(GlobalContext);

  const { roundId } = useRouteInfoState();

  const [displayFlightsForTeams, setDisplayFlightsForTeams] = useState<boolean>();
  const [displayFlightsForIndividuals, setDisplayFlightsForIndividuals] = useState<boolean>();
  const [flightsSectionIsIndividual, setFlightSectionIsIndividual] = useState<boolean>();
  const [buttonsMetadata, setButtonsMetadata] = useState<IButtonMetadata[]>();

  useEffect(() => {
    if (roundId) {
      const eventRoundFormats = adminRoundFormats[Number(roundId)];

      if (eventRoundFormats) {
        setDisplayFlightsForTeams(eventRoundFormats.some(format => format.format.teams));
        setDisplayFlightsForIndividuals(eventRoundFormats.some(format => !format.format.teams));
      }
    }
  }, [adminRoundFormats, roundId]);

  useEffect(() => {
    setFlightSectionIsIndividual(flightsSection === INDIVIDUAL_SECTION);
  }, [flightsSection]);

  useEffect(() => {
    if (
      displayFlightsForTeams !== undefined &&
      displayFlightsForIndividuals !== undefined &&
      flightsSectionIsIndividual !== undefined
    ) {
      const newButtonsMetadata: IButtonMetadata[] = [
        {
          display: displayFlightsForIndividuals,
          inClass: flightsSectionIsIndividual ? '' : 'in',
          section: INDIVIDUAL_SECTION,
          title: 'INDIVIDUAL FLIGHTS',
          variant: flightsSectionIsIndividual ? 'contained' : 'outlined'
        },
        {
          display: displayFlightsForTeams,
          inClass: !flightsSectionIsIndividual ? '' : 'in',
          section: TEAMS_SECTION,
          title: 'TEAMS FLIGHTS',
          variant: !flightsSectionIsIndividual ? 'contained' : 'outlined'
        }
      ];

      setButtonsMetadata(newButtonsMetadata);
    }
  }, [displayFlightsForIndividuals, displayFlightsForTeams, flightsSectionIsIndividual]);

  return (
    <div className="assign-awards-section-selector">
      {buttonsMetadata &&
        buttonsMetadata.map(({ display, inClass, variant, section, title }) =>
          display ? (
            <Button
              classes={{ label: 'list-filter__label' }}
              className={`list-filter list-filter--${inClass}active list-filter--player`}
              color="primary"
              variant={variant}
              onClick={onSectionClick(section)}
            >
              {title}
            </Button>
          ) : (
            <></>
          )
        )}
    </div>
  );
};
